import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Container, Row, Col, Alert, Button } from 'reactstrap';

const ProtectedRoute = ({ children, requiredRole = null, requiredRoles = null, requireAuth = true }) => {
  const { isAuthenticated, hasRole, isAdmin, isManager, loading } = useAuth();

  if (loading) {
    return (
      <Container className="mt-5">
        <div className="text-center">Загрузка...</div>
      </Container>
    );
  }

  if (requireAuth && !isAuthenticated()) {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md="6">
            <Alert color="warning">
              <h4>Требуется авторизация</h4>
              <p>Для доступа к этой странице необходимо войти в систему.</p>
              <Button color="primary" href="/login">
                Войти в систему
              </Button>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  // Check role permissions
  const hasRequiredPermission = () => {
    if (!requiredRole && !requiredRoles) return true;

    // If requiredRoles array is provided, check if user has any of those roles
    if (requiredRoles) {
      return requiredRoles.some(role => hasRole(role));
    }

    // Handle single role with hierarchy logic
    if (requiredRole) {
      // Admin has access to everything
      if (isAdmin()) return true;

      // Manager has access to Manager and User level features
      if (requiredRole === 'Manager' && (isManager() || isAdmin())) return true;

      // Exact role match
      return hasRole(requiredRole);
    }

    return true;
  };

  if (!hasRequiredPermission()) {
    const roleText = requiredRoles ? requiredRoles.join(' or ') : requiredRole;
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md="6">
            <Alert color="danger">
              <h4>Доступ запрещен</h4>
              <p>У вас нет прав для доступа к этой странице. Требуемая роль: {roleText}</p>
              <Button color="secondary" href="/">
                На главную
              </Button>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return children;
};

export default ProtectedRoute;
